import UFOCustomData from '@atlassian/react-ufo/custom-data';

export type { UFOCustomDataProps } from '@atlassian/react-ufo/custom-data';
export { addUFOCustomData } from '@atlassian/react-ufo/custom-data';
export default UFOCustomData;
